import React from 'react';
import { ReactComponent as ExclamationIcon } from '@blink/assets/src/icons/exclamation.svg';

import { userRiskFactorStyle } from './RiskFactor.style';

import { TooltipWrapper } from '@/shared/ui';

export const RiskFactorTooltip = () => {
    const classes = userRiskFactorStyle();

    return (
        <>
            <TooltipWrapper
                text='Risk Factor represents the stability of your position. A Risk Factor above 1 keeps your
                    assets secure, while a value close to or below 1 increases liquidation risk. Maintain a
                    healthy buffer to stay protected'
                icon={<ExclamationIcon />}
            />
            <div className={classes.title}>Risk Factor</div>
        </>
    );
};
